import { render } from "./IconBuilding.vue?vue&type=template&id=087e2d02"
const script = {}

import exportComponent from "/Users/clement/Documents/Projects_Code/flask_energy_demo_platform/code_python/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__